var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconChatRound"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4C6.65765 4 3.00002 7.28789 3.00002 11C3.00002 12.8123 3.84176 14.4819 5.27545 15.7513C5.51052 15.9595 5.63418 16.2659 5.6094 16.5789C5.56268 17.1692 5.32938 18.1693 4.46583 19.5122C5.4114 19.1863 6.48943 18.6472 7.47706 17.7572C7.73806 17.5219 8.10336 17.4409 8.43932 17.5438C9.33396 17.8178 10.8245 17.95 12.526 17.95C14.4738 17.95 16.3525 17.3871 17.7238 16.2639C19.0672 15.1635 20 13.4658 20 11C20 7.28789 16.3424 4 11.5 4ZM2.00002 21V22C1.60022 22 1.23884 21.7619 1.08113 21.3945C0.923406 21.0271 0.999662 20.6011 1.27502 20.3113C2.84267 18.6611 3.36085 17.4815 3.53289 16.8574C1.9769 15.3075 1.00002 13.2711 1.00002 11C1.00002 5.87211 5.8924 2 11.5 2C17.1077 2 22 5.87211 22 11C22 14.0342 20.8218 16.3115 18.9911 17.8111C17.1883 19.2879 14.83 19.95 12.526 19.95C11.0394 19.95 9.54756 19.8562 8.39892 19.599C6.97796 20.7485 5.46777 21.3446 4.28704 21.6547C3.63671 21.8255 3.0788 21.9116 2.67834 21.9551C2.47779 21.9769 2.31579 21.9881 2.2003 21.9939C2.14253 21.9968 2.0963 21.9983 2.06262 21.9991L2.02158 21.9999L2.00832 22L2.00355 22L2.00163 22C2.00124 22 2.00002 22 2.00002 21Z",
    fill: "#002CFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/iconComment.dbd6b915f70ea3b8c529087e84ed5070.svg";
export { ForwardRef as ReactComponent };